import React, { useContext, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/UserContext';
import { FaSignInAlt } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Register = () => {

    const { user, createUser, signInWithGoogle, userProfileName } = useContext(AuthContext)
    const [passwordError, setPasswordError] = useState('');
    const [success, setSuccess] = useState(false)

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";


    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.target;
        const name = form.name.value;
        const email = form.email.value;
        const password = form.password.value;
        console.log(email, password, name);

        if(password.length < 6){
            setPasswordError('Please password should be at least 6 characters');
            return;
        }
        setPasswordError('');

        createUser(email, password)
            .then(result => {
                const user = result.user;
                console.log(user);
                form.reset();
                setSuccess(true)
                updateUserName(name)
            })
            .catch(error => {
                console.error('error', error);
                setPasswordError(error.message)
            })
    }

    const handleGoogleSignIn = () => {
        signInWithGoogle()
            .then(result => {
                const user = result.user;
                console.log(user);
                toast.success('Registered Successfully', { autoClose: 1000 })
                navigate(from, { replace: true })
            })
            .catch(error => {
                console.error('error', error);
            })
    }

    const updateUserName = (name) => {
		userProfileName(name)
		.then(() => {
			console.log('display user name');
		})
		.catch(error => {
			console.error('error', error)
		})
	}


    return (
        <div className="hero min-h-screen bg-base-200">
            <ToastContainer position='top-center'></ToastContainer>
            <div className="hero-content flex-col">
                <div className="text-center lg:text-left">
                    <h1 className="text-5xl font-bold text-center">Please Register!</h1>

                </div>
                <form onSubmit={handleSubmit} className="card width max-w-sm shadow-2xl bg-base-100">
                    <div className="card-body">
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text">Your Name</span>
                            </label>
                            <input name='name' type="text" placeholder="Your Name" className="input input-bordered" required />
                        </div>
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text">Email</span>
                            </label>
                            <input name='email' type="email" placeholder="Your Email" className="input input-bordered" required />
                        </div>
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text">Password</span>
                            </label>
                            <input name='password' type="password" placeholder="Your Password" className="input input-bordered" required />
                            <label className="label">
                                <Link href="#" className="label-text-alt link link-hover">Forgot password?</Link>
                            </label>
                            <p className='text-rose-500'><small>{passwordError}</small></p>
                            {success && <p className='text-green-500'>User Registered Successfully</p>}
                        </div>
                        <div className="form-control mt-6">
                            <button className="btn btn-primary">Register</button>
                        </div>
                        <p className='text-center und'>Already have an account? <Link className='underline' to={'/login'}>LogIn</Link></p>
                        <p className="px-3 text-sm text-center">Login with social accounts</p>
                    </div>
                </form>
                <button onClick={handleGoogleSignIn} className="btn btn-primary "><FaSignInAlt className='mr-3'></FaSignInAlt> Google SignIn</button>
            </div>
        </div>
    );
};

export default Register;